/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const navBar = {

    button: {
        allClassifiers: `Visas klasifikācijas`,
        language: `Valoda`,
        search: `Meklēt`,
        settings: `Iestatījumi`,
    },
    label: {
        accessibility: `Piekļūstamības saturs`,
        contrast: `Kontrasts`,
        cookieSettings: `Sīkdatņu iestatījumi`,
        fontSize: `Burtu izmērs`,
        language: `Valoda`,
        searchClassifier: `Meklēt klasifikāciju`,
    },
}
